import Vue from "vue";
import Vuex from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from "sweetalert2";
import { notificarAdvertencia } from "@/utils/alerts";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    Ejes: [],
    Items: [],
    Plantas: [],
    Loader: true,
    ItemTotal: 0,
    Vehiculos: [],
    TiposValvula: [],
    Inspecciones: [],
    MotivosInaccesibilidad: [],
    ArrayIdInspecciones: [],
    // Estado de observaciones unificado: array de grupos [{tipo, nombre, items[]}]
    Observaciones: [],
    EstadosTuerca: [],
  },
  mutations: {
    LlenarItems(state, data) {
      state.Items = data;
    },
    LlenarVehiculos(state, data) {
      state.Vehiculos = data;
    },
    LlenarPlantas(state, data) {
      state.Plantas = data;
    },
    LlenarEjes(state, data) {
      state.Ejes = data;
    },
    LlenarMotivosInaccesibilidad(state, data) {
      state.MotivosInaccesibilidad = data;
    },
    LlenarTiposValvula(state, data) {
      state.TiposValvula = data;
    },
    LlenarEstadosTuerca(state, data) {
      state.EstadosTuerca = data;
    },
    AgregarEstadoTuerca(state, item) {
      state.EstadosTuerca.push(item);
    },
    AgregarMotivoInaccesibilidad(state, item) {
      state.MotivosInaccesibilidad.push(item);
    },
    LlenarObservaciones(state, data) {
      state.Observaciones = data;
    },
    LlenarItemTotal(state, data) {
      state.ItemTotal = data;
    },
    StateLoader(state, data) {
      state.Loader = data;
    },
  },
  actions: {
    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    recargarObservaciones: async function ({ commit, dispatch }) {
      try {
        const id_cliente = localStorage.getItem("idcliente");
        const response = await axios.get(
          `datosgenerales/codigo/OBS?id_cliente=${id_cliente}`,
        );
        // La respuesta ahora es: { success: true, data: { codigo, grupos: [{tipo, nombre, items[]}] } }
        const listObservaciones = response.data?.data?.grupos ?? [];
        commit("LlenarObservaciones", listObservaciones);
      } catch (error) {
        console.error("Error al recargar observaciones:", error);
        dispatch("messageErrorAlert");
      }
    },

    recargarPorIdentificador: async function (
      { commit, dispatch },
      identificador,
    ) {
      try {
        const id_cliente = localStorage.getItem("idcliente");
        const response = await axios.get(
          `datosgenerales/${identificador}?id_cliente=${id_cliente}`,
        );
        const items = response.data?.data?.items ?? [];
        if (identificador === "TE") {
          let listEstadosTuerca = [];
          items.forEach((element, i) => {
            listEstadosTuerca[i] = {
              value:
                element.numero != null
                  ? element.numero
                  : element.codigo != null
                  ? element.codigo
                  : element.id != null
                  ? element.id
                  : element.dato,
              text: element.dato || element.descripcion || element.nombre,
            };
          });
          commit("LlenarEstadosTuerca", listEstadosTuerca);
        } else if (identificador === "I") {
          let listMotivos = [];
          items.forEach((element, i) => {
            listMotivos[i] = {
              value:
                element.numero != null
                  ? element.numero
                  : element.codigo != null
                  ? element.codigo
                  : element.id != null
                  ? element.id
                  : element.dato,
              text: element.dato || element.descripcion || element.nombre,
            };
          });
          commit("LlenarMotivosInaccesibilidad", listMotivos);
        }
        return response;
      } catch (error) {
        console.error(
          `Error al recargar por identificador ${identificador}:`,
          error,
        );
        dispatch("messageErrorAlert");
      }
    },

    guardarObservacion: async function ({ dispatch }, data) {
      try {
        const response = await axios.post("datosgenerales/store", data);
        const isSuccess =
          response.data &&
          response.data.success &&
          response.data.status !== false;
        if (isSuccess) {
          if (data.identificador === "TE" || data.identificador === "I") {
            await dispatch("recargarPorIdentificador", data.identificador);
          } else {
            await dispatch("recargarObservaciones");
          }
        }
        return response;
      } catch (error) {
        console.error("Error al guardar observación:", error);
        throw error;
      }
    },

    cargarDatosAdicionales: async function ({ commit, dispatch }) {
      try {
        const url = "inspecciones/list";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
        };
        await axios
          .post(url, data)
          .then((response) => {
            let listVehiculos = [];
            response.data.success.vehiculos.forEach((element, i) => {
              listVehiculos[i] = {
                value: element.id,
                text: element.placa + " / " + element.codigo,
                tipovehiculo: element.nomtipo,
                id_tipo: element.id_tipo,
                id_planta: element.id_planta,
                id_configuracion: element.id_configuracion,
              };
            });

            let listPlantas = [];
            response.data.success.plantas.forEach((element, i) => {
              listPlantas[i] = {
                value: element.id,
                text: element.nombre,
              };
            });

            let listEjes = [];
            response.data.success.ejes.forEach((element, i) => {
              listEjes[i] = {
                value: element.id,
                text: element.descripcion,
              };
            });

            let listMotivos = [];
            response.data.success.motivosinaccesibilidad.forEach(
              (element, i) => {
                listMotivos[i] = {
                  value: element.numero,
                  text: element.dato,
                };
              },
            );

            let listTiposValvula = [];
            response.data.success.tiposvalvula.forEach((element, i) => {
              listTiposValvula[i] = {
                value: element.codigo,
                text: element.dato,
              };
            });

            let listEstadosTuerca = [];
            let tuercaestadoData =
              response.data.success.tuercaestado ||
              response.data.success.tuerca_estado ||
              [];
            tuercaestadoData.forEach((element, i) => {
              listEstadosTuerca[i] = {
                value:
                  element.numero != null
                    ? element.numero
                    : element.codigo != null
                    ? element.codigo
                    : element.id != null
                    ? element.id
                    : element.dato,
                text: element.dato || element.descripcion || element.nombre,
              };
            });

            // observaciones ahora es un array de grupos: [{tipo, nombre, items[]}]
            // Cada grupo ya tiene la lista de items para sus selectores
            const listObservaciones = response.data.success.observaciones || [];

            commit("LlenarVehiculos", listVehiculos);
            commit("LlenarPlantas", listPlantas);
            commit("LlenarEjes", listEjes);
            commit("LlenarMotivosInaccesibilidad", listMotivos);
            commit("LlenarTiposValvula", listTiposValvula);
            commit("LlenarEstadosTuerca", listEstadosTuerca);
            commit("LlenarObservaciones", listObservaciones);
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    cargarInspecciones: async function ({ commit, dispatch }, datos) {
      try {
        var url = "inspecciones/getAllInspectionsMinified?";
        for (let dat in datos) {
          url = url + dat + `=${datos[dat]}&`;
        }
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
        };
        commit("StateLoader", true);
        await axios
          .post(url, data)
          .then((response) => {
            response.data.success.resultado.data.forEach((element) => {
              element.loader = false;
            });
            commit("LlenarItems", response.data.success.resultado);
            commit("LlenarItemTotal", response.data.success.total);
            commit("StateLoader", false);
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    cargarInspeccionesPorIdentificador: async function (
      { commit, dispatch },
      identificador,
    ) {
      try {
        let array_id_inspecciones = [];
        const url =
          "inspecciones/getAllInspectionsMinifiedPerIdentifier/" +
          identificador;
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
        };
        await axios
          .post(url, data)
          .then((response) => {
            response.data.success.resultado.forEach((element) => {
              array_id_inspecciones.push(element.id);
            });
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
        return array_id_inspecciones;
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    validarCodigo: async function ({ commit, dispatch }, codigo) {
      try {
        const url = "inspecciones/validateCodigoInspeccion";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          codigo: codigo,
        };
        let existe = false;
        await axios
          .post(url, data)
          .then((response) => {
            existe = response.data.success.respuesta;
          })
          .catch((error) => {
            console.error("error!", error);
            dispatch("messageErrorAlert");
          });
        return existe;
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
      }
    },

    validarFecha: async function ({ commit, dispatch }, item) {
      try {
        const url = "vehiculos/validateFechaInspeccion";
        const data = {
          clienteId: localStorage.getItem("idcliente"),
          id_cliente: localStorage.getItem("idcliente"),
          id_vehiculo: item.id_vehiculo,
          fecha_inspeccion: item.fecha_inspeccion,
        };
        let resultado = { status: false, message: null };
        await axios
          .post(url, data)
          .then((response) => {
            resultado = {
              status: response.data.status,
              message: response.data.message,
            };
          })
          .catch((error) => {
            resultado = {
              status: error.response?.data?.status ?? false,
              message: error.response?.data?.message ?? null,
            };
            console.error("error!", error);
          });
        return resultado;
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
        return { status: false, message: null };
      }
    },

    validarKm: async function ({ commit, dispatch }, item) {
      try {
        const url = "vehiculos/validateKilometraje";
        const data = {
          clienteId: localStorage.getItem("idcliente"),
          id_cliente: localStorage.getItem("idcliente"),
          id_vehiculo: item.id_vehiculo,
          km: item.km_inspeccion,
        };
        let resultado = { status: false, message: null };
        await axios
          .post(url, data)
          .then((response) => {
            resultado = {
              status: response.data.status,
              message: response.data.message,
            };
          })
          .catch((error) => {
            resultado = {
              status: error.response?.data?.status ?? false,
              message: error.response?.data?.message ?? null,
            };
            console.error("error!", error);
          });
        return resultado;
      } catch (error) {
        console.log(error);
        dispatch("messageErrorAlert");
        return { status: false, message: null };
      }
    },

    validarRemanente: async function ({ dispatch }, { item, signal }) {
      try {
        const url = "neumaticos/validateRemanentes";
        const data = {
          clienteId: localStorage.getItem("idcliente"),
          id_cliente: localStorage.getItem("idcliente"),
          id_neumaticos: item.id_neumaticos,
          descripcion: item.descripcion_remanente_validado,
          exterior: item.exterior,
          interior: item.interior,
        };
        const response = await axios.post(url, data, { signal });
        return response.data;
      } catch (error) {
        // axios lanza CanceledError (o AxiosError con code ECONNABORTED/ERR_CANCELED)
        // cuando el AbortSignal dispara; simplemente salir sin mostrar alerta
        if (axios.isCancel(error) || error?.name === "CanceledError" || error?.name === "AbortError") {
          return null;
        }
        const msg = error?.response?.data?.message || null;
        if (msg) return msg;
        console.error("[validarRemanente]", error);
        dispatch("messageErrorAlert");
        return null;
      }
    },
    validarDuplicidad: async function ({ commit, dispatch }, item) {
      try {
        const url = "inspecciones/validate/duplicate";
        const data = {
          clienteId: localStorage.getItem("idcliente"),
          id_cliente: localStorage.getItem("idcliente"),
          id_vehiculo: item.id_vehiculo,
          km_inspeccion: item.km_inspeccion,
          fecha_inspeccion: item.fecha_inspeccion,
        };
        let mensaje = null;
        await axios
          .post(url, data)
          .then((response) => {
            if (response.data.status == false) {
              mensaje = "";
            } else {
              mensaje = response.data.message;
              if (mensaje && mensaje !== "Error de validación") {
                const textoMensaje =
                  typeof mensaje === "string"
                    ? mensaje
                    : JSON.stringify(mensaje);

                notificarAdvertencia({
                  title: "Inspección Registrada",
                  message: textoMensaje,
                  confirmButtonText: "Entendido",
                });
              }
            }
          })
          .catch((error) => {
            mensaje = "";
            console.error("error!", error);
            // dispatch("messageErrorAlert");
          });
        return mensaje;
      } catch (error) {
        console.log(error);

        mensaje = "";
        // dispatch("messageErrorAlert");
      }
    },
  },
};
